import { render, staticRenderFns } from "./WidgetConfigurationSidepanel.vue?vue&type=template&id=86950a52&scoped=true&"
import script from "./WidgetConfigurationSidepanel.vue?vue&type=script&lang=js&"
export * from "./WidgetConfigurationSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConfigurationSidepanel.vue?vue&type=style&index=0&id=86950a52&lang=scss&scoped=true&"
import style1 from "./WidgetConfigurationSidepanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86950a52",
  null
  
)

export default component.exports